import { render, staticRenderFns } from "./PageSignUpPayment.vue?vue&type=template&id=f6364f82"
import script from "./PageSignUpPayment.vue?vue&type=script&lang=js"
export * from "./PageSignUpPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports